import InfosilemReaderNode from './types/infosilem-reader';

export const infosilemNodes = {
  infosilemReader: InfosilemReaderNode,
};
